import { RSAA } from 'redux-api-middleware'

import { getApiPath } from 'sidecar-utility-library'
import initialState, { types } from 'store/Group'

export const clearGroupInfo = () => ({
  type: types.CLEAR_GROUP_INFO,
})

export const fetchGroupInfo = urlSlug => {
  // this is a silly little hack to stop us from requesting
  // group info for 'null' url slugs.
  if (urlSlug === 'null') return

  return {
    [RSAA]: {
      endpoint: getApiPath(`ptnr`, `groups/pub/info?urlSlug=${urlSlug}`),
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY,
      },
      types: [
        types.FETCH_GROUP_INFO_REQUEST,
        types.FETCH_GROUP_INFO_SUCCESS,
        types.FETCH_GROUP_INFO_ERROR,
      ],
    },
  }
}

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.CLEAR_GROUP_INFO: {
      return {
        ...state,
        group: {
          ...state.group,
          info: {},
        },
      }
    }

    // ----------

    case types.FETCH_GROUP_INFO_REQUEST: {
      return {
        ...state,
        group: {
          ...state.group,
          busy: true,
          error: '',
        },
      }
    }
    case types.FETCH_GROUP_INFO_SUCCESS: {
      return {
        ...state,
        group: {
          ...state.group,
          busy: false,
          info: payload,
        },
      }
    }
    case types.FETCH_GROUP_INFO_ERROR: {
      return {
        ...state,
        group: {
          ...state.group,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    // ----------

    default:
      return state
  }
}
